module.exports = __webpack_public_path__ + "img/全球采购与物流.69f67b16.png";